import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { modalActions, commonActions, alertActions, certboxActions } from '../../../../store/actions'
import CertboxAddDoc from './CertboxAddDoc'
import moment from 'moment'
import $ from 'jquery'
import { uriConstants } from '../../../../store/constants'
import Clipboard from 'react-clipboard.js' //2021.05  Bootstrap Icons (>∨)
import { getDeviceType } from '../../../../assets/js/common.js'
import Loading from '../../../../module/loading/Loading'

const CertReceiver = (props) => {
  // const [state, setState] = useState({})
  const [receiverList, setReceiverList] = useState([])
  const [docList, setDocList] = useState([])
  const [crtDvList, setCrtDvList] = useState([])
  const [crtStsCdList, setCrtStsCdList] = useState([])
  const [checkedewallet, setCheckedewallet] = useState(new Set())
  const checkedewalletRef = useRef(checkedewallet)
  const [checkedkakao, setCheckedkakao] = useState(new Set())
  const checkedkakaoRef = useRef(checkedkakao)
  const [walletText1, setWalletText1] = useState('')
  const [walletText2, setWalletText2] = useState('')
  // const [kakaoId, setKakaoId] = useState('')
  // const [kakaoPwd, setKakaoPwd] = useState('')
  const [emailArr, setEmailArr] = useState([])
  const [mailList, setMailList] = useState([])
  // const [walletList, setWalletList] = useState([])
  // const [walletName, setWalletName] = useState([])
  const [showAddDoc, setShowAddDoc] = useState(false)
  // const [checkedDoc, setCheckedDoc] = useState(new Set())
  // const checkedDocRef = useRef(checkedDoc)
  // const [showEdit, setShowEdit] = useState() //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23
  // const [israedingUrl, setIsraedingUrl] = useState(false)
  const [raedingUrl, setRaedingUrl] = useState('')
  const [raedGubun, setRaedGubun] = useState('')
  const [loading, setLoading] = useState(false)

  let [step, setStep] = useState(1)
  let [active, setActive] = useState(1)

  // useEffect(() => {
  //   return () => {
  // 
  //   }
  // }, [])

  useEffect(() => {
    if (mailList && mailList.length > 0) {
      console.log('mailList', mailList)
      props.setEmailText()
    } else {
      props.resetEmailText()
    }
  }, [mailList])

  useEffect(() => {
    if (props.modal.params) {
      let docTempList = []
      let docTempInfo = {}
      for (let cont of props.modal.params) {
        if (cont.sts === '03' || cont.sts === '10' || cont.sts === '12') {
          docTempInfo = {
            crtCd: cont.crtCd,
            sts: cont.sts,
            issuedt: cont.issuedt,
            docid: cont.docid,
            prchsNm: cont.prchsNm,
            fileGroupId: cont.fileGroupId,
            crtRcvSeq: cont.crtRcvSeq,
            crtSeq: cont.crtSeq,
          }
          docTempList.push(docTempInfo)
        }
      }
      setDocList(docTempList)
    } else {
    }
  }, [props.modal.params])
  /*
  useEffect(() => {
    setWalletList(walletList)
  }, [walletList])

  useEffect(() => {
    setWalletName(walletName)
  }, [walletName])
*/
  useEffect(() => {
    if (!props.commoncode) return
    if (props.commoncode?.co.CRT_DV) {
      setCrtDvList(props.commoncode?.co.CRT_DV)
    }

    if (props.commoncode?.co.CRT_STS_CD) {
      setCrtStsCdList(props.commoncode?.co.CRT_STS_CD)
    }
  }, [props.commoncode])

  const makeCrtCd = (crtCd) => {
    const list = crtDvList?.find((crtDv) => crtDv?.cd === crtCd)
    return list ? '[' + list.cdName + ']' : ''
  }

  const makeCrtStsCd = (sts) => {
    const list = crtStsCdList?.find((crtSts) => crtSts.cd === sts)
    return list ? list.cdName : ''
  }

  useEffect(() => {
    if (props.readingInfo) {
      let url = props.readingInfo.url
      let pass = props.readingInfo.pass
      let message =
        '전자문서 열람 URL: \n ' + uriConstants.API_URI + '/service/certread/' + url + ' \n\n 1회열람용 번호 ' + pass + ' 입니다.'
      if (raedGubun === 'B') {
        console.log('readGubun: B')
        props.success({
          title: '1회열람주소생성',
          message: '전자문서 열람 URL 생성되었습니다 \n\n 임시주소 복사로 클립보드에 복사됩니다. \n\n 1회열람용 번호 ' + pass + ' 입니다.',
          params: {
            type: 'SUCCESS',
            callback: () => {
              setRaedingUrl(message)
            },
          },
        })
      } else if (raedGubun === 'C') {
        console.log('readGubun: C')
        props.success({
          title: '1회열람주소생성 및 메일발송',
          message: '전자문서 열람 URL 생성되었습니다 \n\n 임시주소 복사로 클립보드에 복사됩니다. \n\n 1회열람용 번호 ' + pass + ' 입니다.',
          params: {
            type: 'SUCCESS',
            callback: () => {
              setRaedingUrl(message)
              if (props.btnText) {
                props.resetEmailText()
                setMailList([])
                $('button.modal-close.b-close').trigger('click')
                onSelected(1)
              }
            },
          },
        })
      }
      setLoading(false)
      setRaedGubun('')
    }
  }, [props.readingInfo])

  useEffect(() => {
    if (props.isSubmission) {
      props.success({
        title: '제출성공',
        message: '성공적으로 제출되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            props.onClear()
            props.clearModal()
            window.location.href = '/service/certbox'
          },
        },
      })
    }
  }, [props.isSubmission])

  const onSubmit = (gubun) => {
    // 증명서 보내기
    // 1. 업체id, 전자문서코드, 첨부파일, 제출처 전자지갑 주소를 입력받아 필수 입력항목 체크
    // 2. 증명서 송신 api 호출(처리결과 메시지 출력)
    // 3. 목록으로 이동
    if (gubun === 'A') {
      if (receiverList.length < 1) {
        props.error({ message: '수신 대상이 존재하지 않습니다.' })
        return
      } else {
        let submitObj = {
          crtSeq: docList.map((param) => param.crtSeq),
          files: [],
          ewalletIds: receiverList.map((receiver) => receiver.ewalletId),
        }

        props.createCrtfSubmit(submitObj)
      }
    } else {
      let readingObj = {
        crtSeq: docList.map((param) => param.crtSeq),
        mailList: mailList.map((param) => param.emailArr),
      }
      setLoading(true)
      setRaedGubun(gubun)
      props.createCrtfReading(readingObj)
    }
  }

  // const onKakaoSearch = () => {
  //   // 카카오 친구목록 가져오기
  //   // 1. 카카오 로그인
  //   // 2. 증명서 송신 api 호출(처리결과 메시지 출력)
  //   // 3. 목록으로 이동

  //   if (receiverList.length < 1) {
  //     props.error({ message: '수신 대상이 존재하지 않습니다.' })
  //     return
  //   }

  //   let kakaoObj = {
  //     kakaoId: kakaoId,
  //     kakaoPwd: kakaoPwd,
  //   }

  //   props.kakaoSearch(kakaoObj)
  // }

  const onMailAdd = () => {
    // 메일주소 추가
    // 1. 메일주소 입력여부 확인
    // 2. 기존 메일리스트 가져오기
    // 3. 추가된 메일정보 메일리스트에 추가

    if (emailArr === '' || emailArr === null || emailArr === undefined) {
      props.error({ message: '추가할 메일주소를 입력하세요.' })
      return
    }
    let tempMail = []
    for (let cont of mailList) {
      tempMail.push(cont)
    }
    let emailoObj = {
      emailArr: emailArr,
    }
    tempMail.push(emailoObj)
    setMailList(tempMail)
    setEmailArr('')
  }

  const onDelMail = (mail) => {
    // 메일주소 삭제
    // 1. 메일
    // 2. 증명서 송신 api 호출(처리결과 메시지 출력)
    // 3. 목록으로 이동

    let tempMail = []
    for (let cont of mailList) {
      if (mail.emailArr !== cont.emailArr) {
        tempMail.push(cont)
      }
    }
    setMailList(tempMail)
    setEmailArr('')
  }

  const onSelected = (value) => {
    setCheckedewallet(new Set())
    checkedewalletRef.current.clear()
    setReceiverList(checkedewalletRef.current)
    setCheckedkakao(new Set())
    checkedkakaoRef.current.clear()
    setWalletText1('')
    setWalletText2('')
    props.searchWalletAddr({ keyword: 'XXXXXXXX', gubun: 1 })
    setStep(value)
    setActive(1)
  }
  const onActive = (value) => {
    setActive(value)
  }

  // 일회용열람 이메일 보내기 취소 시 사용되는 함수
  const onCancel = (value) => {
    setCheckedewallet(new Set())
    checkedewalletRef.current.clear()
    setCheckedkakao(new Set())
    checkedkakaoRef.current.clear()
    setWalletText1('')
    setWalletText2('')
    props.searchWalletAddr({ keyword: 'XXXXXXXX', gubun: 1 })
    setActive(1)
  }

  const handleKeyPressWallet1 = (e) => {
    if (e.key === 'Enter') {
      props.searchWalletAddr({ keyword: walletText1, gubun: 1 })
    }
  }

  const clickWallet1 = () => {
    props.searchWalletAddr({ keyword: walletText1, gubun: 1 })
  }

  const handleKeyPressWallet2 = (e) => {
    if (e.key === 'Enter') {
      props.searchWalletAddr({ keyword: walletText2, gubun: 2 })
    }
  }
  const clickWallet2 = () => {
    props.searchWalletAddr({ keyword: walletText2, gubun: 2 })
  }

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setState({
  //     ...state,
  //     [name]: value,
  //   })
  // }

  const checkedEwalletItemHandler = (id, isChecked, ewalletId, name, obj) => {
    if (isChecked) {
         checkedewalletRef.current.add(obj)
    } else {
      for (let cont of checkedewalletRef.current) {
        if (obj.ewalletId == cont.ewalletId) {
          checkedewalletRef.current.delete(cont)
        }
      }
    }
    setCheckedewallet(checkedewalletRef.current)
    changeEwalletShowForm()
  }

  const checkEwalletHandler = ({ target }, ewallet) => {
    // if (checkedewalletRef.current.size === 0) {
      checkedEwalletItemHandler(target.id, target.checked, ewallet.ewalletId, ewallet.name, ewallet)
    // } else {
    //   props.error({ message: '수신 대상자는 한개만 가능 합니다.' })
    //   return
    // }
  }

  //복수 제어 함수
  const changeEwalletShowForm = () => {
    // setShowEdit(checkedewalletRef.current.size)
    setReceiverList(Array.from(checkedewalletRef.current))
  }

  // const checkedKakaoItemHandler = (id, isChecked, crtSeq, sts, crtRcvSeq, obj) => {
  //   if (isChecked) {
  //     checkedkakaoRef.current.add(obj)
  //   } else {
  //     for (let cont of checkedkakaoRef.current) {
  //       if (obj === cont) {
  //         checkedkakaoRef.current.delete(cont)
  //       }
  //     }
  //   }
  //   setCheckedkakao(checkedkakaoRef.current)
  // }

  // const checkKakaoHandler = ({ target }, certbox) => {
  //   checkedKakaoItemHandler(target.id, target.checked, certbox.crtSeq, certbox.sts, certbox.crtRcvSeq, certbox)
  // }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '100',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '101',
    display: 'block',
    top:'35em'
    
  }

  let styleOn = {
    display: 'block',
  }

  let styleOff = {
    display: 'none',
  }

  let styleDiv1 = {
    maxHeight: 'calc(50vh - 5rem)',
  }

  /**
   * 내문서의 조회된 증명서 목록으로 증명서 추가 팝업창
   * @returns {*}
   */
  const openAddDoc = () => {
    setShowAddDoc(true)
  }

  const checkedDocItemHandler = (crtSeq, sts, crtRcvSeq, obj) => {
    let docTempList = []
    for (let cont of docList) {
      if (obj !== cont) {
        docTempList.push(cont)
      }
    }
    setDocList(docTempList)
    setRaedingUrl('')
  }

  const checkDocHandler = (certbox) => {
    checkedDocItemHandler(certbox.crtSeq, certbox.sts, certbox.crtRcvSeq, certbox)
  }
  //console.log('docList = ', docList);

  const setDocAdd = (info) => {
    let docTempList = []
    for (let cont of docList) {
      docTempList.push(cont)
    }
    for (let cont of info) {
      console.log('cont = ', cont)
      docTempList.push(cont)
    }
    setDocList(docTempList)
    setRaedingUrl('')
  }
  //console.log('docList = ', docList);

  const raedingUrlCopy = (url) => {
    if (url) {
      props.error({ title: '확인', message: '임시주소가 복사되었습니다.' })
    } else {
      props.error({ title: '확인', message: '1회열람주소생성을 먼저 해주시기 바랍니다.' })
    }
  }

  // 기관/법인 검색 모바일 Toggle 처리
  const toggleHandler = (e) => {
    $('.current-menu').toggleClass('on')
  }
  const selectNav = ({ target }) => {
    const { text } = target
    $('.current-menu').text(text).toggleClass('on')
  }

  const openKaKaoTalk = () => {
    if (!raedingUrl) {
      return props.error({ title: '확인', message: '1회열람주소생성을 먼저 해주시기 바랍니다.' })
    }

    window.M.execute(
      'exWNKakaoLinkTextTemplate',
      raedingUrl,
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(result)
          window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
        })
        .toString(),
    )
  }

  const modalClose = ()=>{
    // 창 닫기시 보드에 저장된 내용 초기화
    setRaedingUrl('')
    props.clearModal(true)
  }
  
  return (
    <React.Fragment>
      {loading ? <Loading /> : null}
      {props.modal.isShow ? (
        <div>
          <div style={style}></div>
          <div style={styleModal} id="document-register" className="modal w1120">
            <div className="modal-head">
              <h3 className="h3-tit first">선택한 증명서</h3>
            </div>
            <div className="modal-cont mobile-scroll" style={styleDiv1}>
              <table className="tbl-list">
                <caption>증명서 및 상태, 발급일시, 발급번호, 발급처, 삭제 항목으로 구성</caption>
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '15%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">증명서 및 상태</th>
                    <th scope="col">발급일시</th>
                    <th scope="col">발급번호</th>
                    <th scope="col">발급처</th>
                    <th scope="col">삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {docList?.length > 0 ? (
                    docList?.map((certboxInfo, index) => (
                      <tr key={index}>
                        <td className="cell" data-title={'증명서 및 상태'}>
                          {makeCrtCd(certboxInfo.crtCd)} - {makeCrtStsCd(certboxInfo.sts)}
                        </td>
                        <td className="cell" data-title={'발급일시'}>
                          {moment(certboxInfo.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD HH:mm:ss')}
                        </td>
                        <td className="cell" data-title={'발급번호'}>
                          {certboxInfo.docid}
                        </td>
                        <td className="cell" data-title={'발급처'}>
                          {certboxInfo.prchsNm}
                        </td>
                        <td className="cell" data-title={'삭제'}>
                          <a
                            href="#"
                            className="btn-secondary md"
                            onClick={(e) => {
                              e.preventDefault()
                              checkDocHandler(certboxInfo)
                              return
                            }}
                          >
                            삭제하기
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <div className="nodata">등록된 자료가 없습니다.</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="btn-block center">
                <a href="#" className="btn-primary md" onClick={openAddDoc}>
                  증명서 추가
                </a>
              </div>
            </div>
            <div className="modal-cont mobile-scroll">
              <ul className="nav-tab">
                <li
                  className={step === 1 ? 'on' : ''}
                  onClick={() => {
                    onSelected(1)
                  }}
                >
                  <a href="#">기관/법인 검색</a>
                </li>
                <li
                  className={step === 2 ? 'on' : ''}
                  onClick={() => {
                    onSelected(2)
                  }}
                >
                  <a href="#">지갑 주소</a>
                </li>
                <li
                  className={step === 3 ? 'on' : ''}
                  onClick={() => {
                    onSelected(3)
                  }}
                >
                  <a href="#">1회 열람</a>
                </li>
              </ul>
            </div>
            {/* mobile */}
            <div className="nav-wrap">
              <a href="#" className="current-menu" onClick={toggleHandler}>
                기관/법인 검색
              </a>
              <ul className="nav-menu">
                <li
                  className={step === 1 ? 'on' : ''}
                  onClick={() => {
                    onSelected(1)
                  }}
                >
                  <a href="#" onClick={selectNav}>
                    기관/법인 검색
                  </a>
                </li>
                <li
                  className={step === 2 ? 'on' : ''}
                  onClick={() => {
                    onSelected(2)
                  }}
                >
                  <a href="#" onClick={selectNav}>
                    지갑 주소
                  </a>
                </li>
                <li
                  className={step === 3 ? 'on' : ''}
                  onClick={() => {
                    onSelected(3)
                  }}
                >
                  <a href="#" onClick={selectNav}>
                    1회 열람
                  </a>
                </li>
              </ul>
            </div>
            {/* //mobile */}
            {step === 1 && (
              <div id="sent-tab1" className="modal-cont mobile-scroll">
                <div className="search-box center mt15">
                  <div className="row">
                    <div className="inquiry-group">
                      <input
                        type="text"
                        placeholder="기관 또는 법인(대표자) 입력하세요."
                        className="form-keyword"
                        id="walletText1"
                        name="walletText1"
                        value={walletText1 || ''}
                        onChange={({ target }) => setWalletText1(target.value)}
                        onKeyPress={handleKeyPressWallet1}
                      />
                      <a href="#" className="btn-primary sm cursor" onClick={clickWallet1}>
		              	검색
		              </a> 
                    </div>
                  </div>
                </div>
                {getDeviceType() === 'MobileApp' ? (
                  <div className="tbl-wrap">
                    <table className="tbl-list">
                      <caption>선택, 성명, 전자지갑주소 항목으로 구성</caption>
                      <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '65%' }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">성명</th>
                          <th scope="col">전자지갑주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.walletList?.length > 0 ? (
                          props.walletList?.map((info, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  id={`${'row-' + info.ewalletId + index}`}
                                  onChange={(e) => checkEwalletHandler(e, info)}
                                  checked={Object.keys(receiverList.filter((list) => info.ewalletId === list.ewalletId)).length}
                                />
                                <em></em>
                              </td>
                              <td className="cell" data-title={'성명'}>
                                {info.name}
                              </td>
                              <td className="cell" data-title={'전자지갑주소'}>
                                {info.ewalletId}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <div className="nodata">등록된 자료가 없습니다.</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    className="modal-cont mobile-scroll"
                    style={{
                      maxHeight: 'calc(50vh - 20rem)',
                      borderTop: '2px solid #3daaf7',
                    }}
                  >
                    <table className="tbl-list">
                      <caption>선택, 성명, 전자지갑주소 항목으로 구성</caption>
                      <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '65%' }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">성명</th>
                          <th scope="col">전자지갑주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.walletList?.length > 0 ? (
                          props.walletList?.map((info, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  id={`${'row-' + info.ewalletId + index}`}
                                  onChange={(e) => checkEwalletHandler(e, info)}
                                  checked={Object.keys(receiverList.filter((list) => info.ewalletId === list.ewalletId)).length}
                                />
                                <em></em>
                              </td>
                              <td className="cell" data-title={'성명'}>
                                {info.name}
                              </td>
                              <td className="cell" data-title={'전자지갑주소'}>
                                {info.ewalletId}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <div className="nodata">등록된 자료가 없습니다.</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                {/*<div className="modal-cont mobile-scroll" style={{maxHeight: 'calc(50vh - 20rem)'}}>*/}
                {/*  <table className="tbl-list">*/}
                {/*    <caption>선택, 성명, 전자지갑주소 항목으로 구성</caption>*/}
                {/*    <colgroup>*/}
                {/*      <col style={{ width: '30%' }} />*/}
                {/*      <col style={{ width: '65%' }} />*/}
                {/*    </colgroup>*/}
                {/*    <thead>*/}
                {/*    <tr>*/}
                {/*      <th scope="col">성명</th>*/}
                {/*      <th scope="col">전자지갑주소</th>*/}
                {/*    </tr>*/}
                {/*    </thead>*/}
                {/*    <tbody>*/}
                {/*    </tbody>*/}
                {/*  </table>*/}
                {/*</div>*/}
                <div className="btn-block center">
                  <a
                    href="#"
                    className="btn-primary lg w200"
                    onClick={(e) => {
                      e.preventDefault()
                      onSubmit('A')
                    }}
                  >
                    제출
                  </a>
                </div>
              </div>
            )}
            {step === 2 && (
              <div id="sent-tab2" className="modal-cont mobile-scroll">
                <div className="search-box center mt15">
                  <div className="row">
                    <span className="tit">지갑주소</span>
                    <input
                      type="text"
                      placeholder="지갑주소를 입력하세요."
                      className="form-keyword"
                      id="walletText2"
                      name="walletText2"
                      value={walletText2 || ''}
                      onChange={({ target }) => setWalletText2(target.value)}
                      onKeyPress={handleKeyPressWallet2}
                    /> 
                    <a href="#" className="btn-primary sm cursor" onClick={clickWallet2}>
		              	검색
		              </a> 
                  </div>
                </div>
                {getDeviceType() === 'MobileApp' ? (
                  <div className="tbl-wrap">
                    <table className="tbl-list">
                      <caption>선택, 성명, 전자지갑주소 항목으로 구성</caption>
                      <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '65%' }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">성명</th>
                          <th scope="col">전자지갑주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.walletList?.length > 0 ? (
                          props.walletList?.map((info, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  id={`${'row-' + info.ewalletId + index}`}
                                  onChange={(e) => checkEwalletHandler(e, info)}
                                  checked={Object.keys(receiverList.filter((list) => info.ewalletId === list.ewalletId)).length}
                                />
                                <em></em>
                              </td>
                              <td className="cell" data-title={'성명'}>
                                {info.name}
                              </td>
                              <td className="cell" data-title={'전자지갑주소'}>
                                {info.ewalletId}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <div className="nodata">존재하지 않는 지갑주소 입니다.</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    className="modal-cont mobile-scroll"
                    style={{
                      maxHeight: 'calc(50vh - 20rem)',
                      borderTop: '2px solid #3daaf7',
                    }}
                  >
                    <table className="tbl-list">
                      <caption>선택, 성명, 전자지갑주소 항목으로 구성</caption>
                      <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '65%' }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">성명</th>
                          <th scope="col">전자지갑주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.walletList?.length > 0 ? (
                          props.walletList?.map((info, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  id={`${'row-' + info.ewalletId + index}`}
                                  onChange={(e) => checkEwalletHandler(e, info)}
                                  checked={Object.keys(receiverList.filter((list) => info.ewalletId === list.ewalletId)).length}
                                />
                                <em></em>
                              </td>
                              <td className="cell" data-title={'성명'}>
                                {info.name}
                              </td>
                              <td className="cell" data-title={'전자지갑주소'}>
                                {info.ewalletId}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <div className="nodata">존재하지 않는 지갑주소 입니다.</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="btn-block center">
                  <a
                    href="#"
                    className="btn-primary lg w200"
                    onClick={(e) => {
                      e.preventDefault()
                      onSubmit('A')
                    }}
                  >
                    보내기
                  </a>
                </div>
              </div>
            )}
            {step === 3 && (
              <div id="sent-tab3" className="modal-cont mobile-scroll">
                <div className={active === 1 ? 'reading-box mt15' : 'search-box center mt15'}>
                  <div id="copyTab" className="box copy" style={active === 1 ? styleOn : styleOff}>
                    <a href="#" onClick={() => raedingUrlCopy(raedingUrl)}>
                      <Clipboard className="text btn-copy" data-clipboard-text={raedingUrl}>
                        <i className="ico"></i>
                        <p>임시주소 복사</p>
                      </Clipboard>
                    </a>
                  </div>
                  {getDeviceType() === 'MobileApp' && (
                    <div id="kakaoTab" className="box kakao" style={active === 1 ? styleOn : styleOff}>
                      <a href="#" onClick={openKaKaoTalk}>
                        <i className="ico"></i>
                        <p>카카오톡으로 열람</p>
                      </a>
                    </div>
                  )}

                  <div id="emailTab" className="box email" style={active === 1 ? styleOn : styleOff}>
                    <a
                      onClick={() => {
                        onActive(3)
                      }}
                    >
                      <i className="ico"></i>
                      <p>이메일로 보내기</p>
                    </a>
                  </div>
                  {/*
                  <div id="kakaoSearch" className="row" style={ active === 2  ? styleOn : styleOff }>
                    <div className="inquiry-group">
                      <input type="text" 
                          placeholder="카카오ID 입력하세요." 
                          className="form-keyword"
                            id="kakaoId" name ="kakaoId"
                            value = {kakaoId || ''}
                            onChange={({ target }) => setKakaoId(target.value)}
                      />
                      <input type="text" 
                          placeholder="카카오 비밀번호 입력하세요." 
                          className="form-keyword"
                            id="kakaoPwd" name ="kakaoPwd"
                            value = {kakaoPwd || ''}
                            onChange={({ target }) => setKakaoPwd(target.value)}
                      />
                      <button type="button" className="btn-search" onClick={() => onKakaoSearch()}>검색</button>
                    </div>
                  </div>
					      */}
                  <div id="emailSearch" className="row" style={active === 3 ? styleOn : styleOff}>
                    <div className="inquiry-group">
                      <input
                        type="text"
                        placeholder="메일주소를 입력하세요."
                        className="form-keyword"
                        id="emailArr"
                        name="emailArr"
                        value={emailArr || ''}
                        onChange={({ target }) => setEmailArr(target.value)}
                      />
                      <button type="button" className="btn-gray" onClick={() => onMailAdd()}>
                        메일추가
                      </button>
                    </div>
                  </div>
                </div>
                {/*
		          <div id="kakaoInfo" className="tbl-wrap" style={ active === 2  ? styleOn : styleOff }>
		            <table className="tbl-list">
		              <colgroup>
	              		<col style={{width: '5%'}} />
		                <col style={{width: '50%' }} />
		                <col style={{width: '55%' }} />
		              </colgroup>
		              <thead>
		                <tr>
	                	  <th scope="col">선택</th>
		                  <th scope="col">카카오닉네임</th>
		                  <th scope="col">카카오ID</th>
		                </tr>
		              </thead>
		              <tbody>
		                {props.kakaoList?.length > 0 ? (
                        	props.kakaoList?.map((kakao, index) => (
		                    <tr key={index}>
			                  <td>
			                      <input type="checkbox" id={`${"row-" + kakao.id + index}`}
			                             onChange={(e) => checkKakaoHandler(e, kakao)}
			                             checked={checkedkakaoRef.current.has(kakao)}
			                      /><em></em>
			                  </td>
		                      <td className="cell" data-title={'카카오닉네임'}>
		                        {kakao.profile_nickname}
		                      </td>
		                      <td className="cell" data-title={'카카오ID'}>
		                        {kakao.id}
		                      </td>
		                    </tr>
		                  ))
		                ) : (
		                  <tr>
		                    <td colSpan={3}>
		                      <div className="nodata">등록된 자료가 없습니다.</div>
		                    </td>
		                  </tr>
		                )}
		              </tbody>
		            </table>
		            <div className="btn-block center">
		              <a href="#" className="btn-secondary md" onClick={() => onCancel('kakao')}>취소</a>
		            </div>
		          </div>
					*/}
                <div id="emailInfo" className="tbl-wrap" style={active === 3 ? styleOn : styleOff}>
                  <table className="tbl-list">
                    <caption>메일주소, 메일삭제 항목으로 구성</caption>
                    <colgroup>
                      <col style={{ width: '70%' }} />
                      <col style={{ width: '30%' }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">메일주소</th>
                        <th scope="col">메일삭제</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mailList?.length > 0 ? (
                        mailList?.map((mail, index) => (
                          <tr key={index}>
                            <td className="cell" data-title={'메일주소'}>
                              {mail.emailArr}
                            </td>
                            <td className="cell" data-title={'메일삭제'}>
                              <a
                                href="#"
                                className="btn-secondary md"
                                onClick={(e) => {
                                  e.preventDefault()
                                  onDelMail(mail)
                                  return
                                }}
                              >
                                삭제하기
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3}>
                            <div className="nodata">등록된 자료가 없습니다.</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="btn-block center" style={active === 1 ? styleOn : styleOff}>
                  <a
                    href="#"
                    className="btn-primary lg w200"
                    onClick={(e) => {
                      e.preventDefault()
                      onSubmit('B')
                    }}
                  >
                    {props.btnText ? props.btnText : '1회열람주소생성'}
                  </a>
                </div>
                <div className="btn-block center" style={active === 3 ? styleOn : styleOff}>
                  <a
                    href="#"
                    className="btn-primary lg w200"
                    onClick={(e) => {
                      e.preventDefault()
                      onSubmit('C')
                    }}
                  >
                    {props.btnText ? props.btnText : '1회열람주소생성'}
                  </a>
                  <a href="#" className="btn-secondary lg" onClick={() => onCancel('email')}>
                    취소
                  </a>
                </div>
              </div>
            )}
            <button type="button" className="modal-close b-close" onClick={()=>modalClose()}>
              창닫기
            </button>
          </div>
        </div>
      ) : (
        ''
      )}

      {showAddDoc === true && (
        <CertboxAddDoc
          commoncode={props.commoncode}
          onClose={() => setShowAddDoc(false)}
          certboxIn={props.modal.params}
          certboxOut={props.modal.orgparams}
          onDocAdd={setDocAdd}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxInfo: state.certbox?.info,
    isSubmission: state.certbox?.isSubmission,
    // isReading: state.certbox?.isReading,
    commoncode: state.commoncode,
    modal: state.modal,
    walletList: state.certbox?.walletList,
    walletName: state.certbox?.walletName,
    readingInfo: state.certbox?.readingInfo,
    btnText: state.certbox?.btnText,
  }
}

const actionCreators = {
  clearModal: modalActions.clearModal,
  createCrtfSubmit: certboxActions.createCrtfSubmit,
  createCrtfReading: certboxActions.createCrtfReading,
  searchWalletAddr: certboxActions.getWalletAddr,
  searchWalletName: certboxActions.getWalletName,
  resetWalletList: certboxActions.resetWalletList,
  success: alertActions.success,
  common: commonActions.getCommonCode,
  error: alertActions.error,
  onClear: certboxActions.onClear,
  setEmailText: certboxActions.setEmailText,
  resetEmailText: certboxActions.resetEmailText,
}

export default connect(mapStateToProps, actionCreators)(CertReceiver)
